import { combineReducers } from "redux";
import { DeliveryAddress } from "~/types";
import { Action } from "../action";

export interface DeliveryAddressState {
  deliveryAddresses: DeliveryAddress[];
}

export const reducer = combineReducers<DeliveryAddressState, Action>({
  deliveryAddresses,
});

function deliveryAddresses(state: DeliveryAddress[] = [], action: Action) {
  switch (action.type) {
    case "SET_DELIVERY_ADDRESS":
      return [action.deliveryAddress, ...state].slice(0, 3);
    case "INIT_ACTION":
      return action.deliveryAddresses;
  }
  return state;
}

export function getDeliveryAddress(
  state: DeliveryAddressState,
): DeliveryAddress | null {
  return state.deliveryAddresses[0] || null;
}

export function getDeliveryAddresses(
  state: DeliveryAddressState,
): DeliveryAddress[] {
  return state.deliveryAddresses;
}
